export default "__VITE_ASSET__GNiEgDkn__"